import React, { Component } from 'react';
import styled from 'styled-components';
import { theme } from '@upsolve/ui';

import LinkCSS from '../Links/A.css';
import Page from './Page.div';
import Button from '../Inputs/Button.span';

import AboutPanel from './AboutPanel';
import LearnListingPanel from '../Learn/LearnListingPanel';


const FooterContainer = styled.footer`
  background: ${theme.colors.white['700']};
  a {
    ${LinkCSS}
    font-size: 14px;
  }
  ${ Page } > div {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 45em) {
      flex-direction: column;
    }
    & > div {
      flex-grow: 1;
      padding: 1em;
    }
  }
  li, p {
    font-size: .8em;
  }
  iframe {
    border: 0;
    max-width: 100%;
    width: 100%;
  }
  @media screen and (max-width: 45em) {
    li {
      font-size: 1em;
      padding-bottom: 0.25em;
    }
  }
`;

const AttorneyCTA = styled.div`
  background: ${props => props.theme.colors.white['700']};
  & > div {
    max-width: 960px;
    margin: 0 auto;
    text-align: center;
    padding: 2em 1em;
    color: ${props => props.theme.colors.brand['500']};
    & > a {
      color: ${props => props.theme.colors.brand['500']};
    }
    button {
      margin-top: 1em;
    }
  }
`;

class MainFooter extends Component {
  render() {
    return (
      <div>
        {this.props.showArticles === true && <LearnListingPanel />}
        {this.props.showAttorneyLink === true && (
          <AttorneyCTA>
            <div>
              <a href="https://local.upsolve.org/join">
                <b>Are you a bankruptcy attorney?</b><br />Create a profile on Upsolve and get exposed to hundreds of clients ready to file bankruptcy.
                <br />
                <Button buttonType="white">Create an Attorney Profile</Button>
              </a>
            </div>
          </AttorneyCTA>
        )}
        <AboutPanel />
        <FooterContainer>
          <Page>
            <div>
              <div>
                <h4>Organization</h4>
                <ul>
                  <li><a href="/team/">Team</a></li>
                  <li><a href="/supporters/">Supporters</a></li>
                  <li><a href="/press/">Press</a></li>
                  <li><a href="/donate/">Donate</a></li>
                  <li><a href="/careers/">Careers</a></li>
                </ul>
              </div>
              <div>
                <h4>Need help?</h4>
                <ul>
                  <li><a href="/learn/category/support/">Support Articles</a></li>
                  <li><a href="/learn/">Learning Center</a></li>
                  <li><a href="/legal-definitions/">Legal Definitions</a></li>
                  <li><a href="/browse/">Help By Location</a></li>
                </ul>
              </div>
              <div>
                <h4>Terms & Privacy</h4>
                <ul>
                  <li><a href="/terms-of-service/">Terms of Service</a></li>
                  <li><a href="/terms-of-use/">Terms of Use</a></li>
                  <li><a href="/privacy-policy/">Privacy Policy</a></li>
                </ul>
              </div>
              <div>
                <h4>Made in NYC 🗽</h4>
              </div>
            </div>
          </Page>
        </FooterContainer>
      </div>
    );
  }
}

export default MainFooter
